import React from 'react';
import { Form } from "../../../collections/Form";
import { Modal } from "../../../elements/Modal";
import { TextInput } from "../../../inputs/TextInput";
export var getForgotPasswordFormMarkup = function getForgotPasswordFormMarkup(onForgotPasswordSubmit, forgotPasswordSubmitButtonText, forgotPasswordEmailInputLabel, forgotPasswordHeadingText, forgotPasswordModalTriggerText, forgotPasswordValidation, forgotPasswordErrorMessage, forgotPasswordSuccessMessage) {
  return React.createElement(Modal, {
    trigger: React.createElement("span", null, forgotPasswordModalTriggerText)
  }, React.createElement(Form, {
    errorMessage: forgotPasswordErrorMessage,
    headingText: forgotPasswordHeadingText,
    onSubmit: onForgotPasswordSubmit,
    submitButtonText: forgotPasswordSubmitButtonText,
    successMessage: forgotPasswordSuccessMessage,
    validation: forgotPasswordValidation
  }, React.createElement(TextInput, {
    autoComplete: "email",
    label: forgotPasswordEmailInputLabel,
    name: "email"
  })));
};